module.exports = __webpack_public_path__ + "assets/img/btn-view-bc208f46.png";